<template>
    <div class="">
        <div style="text-align: center;font-size: 16px;margin-top: 40%">出错了！</div>
    </div>
</template>
<script>
    export default {
        name: 'error',
        data() {
            return {
            }
        },
        created: function () {

        },
        methods: {

        }
    }
</script>

<style>
</style>